module.exports = __webpack_public_path__ + "assets/img/question_mark.d74e7ca0.svg";